export class ConsignorElement {

    UserId:number;
    ConsignorId:number;
    Country_Id:number;  State_Id:number;  City_Id:number;

    FullName :string;
    MobileNumber :string;
    PinCode :string;
    FlatHouseNoBuildingCompanyApartment :string;
    AreaColonyStreetSectorVillage :string;
    LandMark :string;
    SetDefault:number;

    OperationType :string;
    //IsActive { get; set; }
    CreatedBy :number;
    //CreatedDateTime { get; set; }
    Notes :string;
    MachineIP  :string;

    IsBillShippingAddressSame :string;


    }
